import { collaboratorService } from '@/data/services/collaborator/collaborator-service'
import { Account } from '@/domain/usecases'
import { FilterOptions } from '@/data/services/collaborator/collaborator-service-types'

export type CompanyManagerCollaboratorsLoaderType = {
  filterOptions: FilterOptions
}

export async function loadCompanyManagerCollaborators(
  account: Account.Model
): Promise<CompanyManagerCollaboratorsLoaderType> {
  try {
    const filterOptions = await collaboratorService.fetchFilterOptions(account.company.uniqueId)
    return { filterOptions }
  } catch (error) {
    console.error('Error loading collaborator filters:', error)
    return {
      filterOptions: {
        departments: [],
        jobs: [],
        companies: [],
        accountTypes: [],
        typegroup: []
      }
    }
  }
}
